import { render, staticRenderFns } from "./myCalendar.vue?vue&type=template&id=2656cc03&scoped=true&"
import script from "./myCalendar.vue?vue&type=script&lang=js&"
export * from "./myCalendar.vue?vue&type=script&lang=js&"
import style0 from "./myCalendar.vue?vue&type=style&index=0&id=2656cc03&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2656cc03",
  null
  
)

export default component.exports